import { Link } from 'react-router-dom';
import { Home, ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';

// صفحة 404 — أي مسار مش معرّف في الراوتر
const NotFound = () => (
  <div className="container mx-auto px-4 py-20 md:py-28 flex flex-col items-center text-center">
    <span className="font-tajawal font-black text-[7rem] md:text-[10rem] leading-none text-burgundy-500/15 select-none" dir="ltr">
      404
    </span>
    <h1 className="font-tajawal font-bold text-2xl md:text-3xl text-brand-black -mt-6 md:-mt-10 mb-3">الصفحة غير موجودة</h1>
    <p className="font-cairo text-gray-500 mb-8 max-w-md">
      الرابط اللي فتحتيه غلط أو الصفحة انتقلت. ارجعي للرئيسية أو كمّلي تسوق.
    </p>
    <div className="flex flex-wrap justify-center gap-3">
      <Link to="/">
        <Button className="bg-burgundy-500 hover:bg-burgundy-600 rounded-full px-8 font-cairo gap-2">
          <Home className="w-4 h-4" />
          الرئيسية
        </Button>
      </Link>
      <Link to="/products">
        <Button variant="outline" className="rounded-full px-8 font-cairo gap-2 border-burgundy-500/30 text-burgundy-500 hover:bg-burgundy-500/5">
          <ShoppingBag className="w-4 h-4" />
          تصفحي المنتجات
        </Button>
      </Link>
    </div>
  </div>
);

export default NotFound;
